import React from 'react'
import { Trans } from '@lingui/macro'
import { _ } from '../../utils/intl'
import { Notice, Icon, Button } from '../../ui-kit'
import { ActivateDeactivateCardModal } from './ActivateDeactivateCardModal'
import { CardsStore } from '../../../end-user/dashboard/CardsStore'
import { useDialog } from '../../utils/hooks/useDialog'

export const ActivateCardTip: React.SFC<{
  cards: CardsStore
}> = ({ cards }) => {
  const d = useDialog()

  return (
    <>
      <Button onClick={d.open} className="hide">
        <Trans>Aktivovať kartu</Trans>
      </Button>
      <Notice
        id="activate-card-tip"
        type="tip"
        renderIcon={() => <Icon name="bulb" size="xlarge" className="text-vam" />}
        closable
        closeSize="large"
        className="text-color-turquoise-600 mb-xlarge">
        <div className="text-color-black">
          <Trans>Vaša jedálna karta zatiaľ nebola aktivovaná</Trans>
        </div>
        <a className="link-black text-bold text-color-turquoise-600" onClick={d.open}>
          <Trans>Aktivovať kartu</Trans>
        </a>
      </Notice>
      {d.isOpen && <ActivateDeactivateCardModal close={d.close} type="activate" cards={cards} />}
    </>
  )
}
